<template>
  <div>
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addCustom"/>
      </div>

    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" :deleteTipInfo="'是否确认删除该配置'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" @deleteLine="deleteLine" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :selection="false" :operationArr="operationArr" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/ParkingService'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'parking-temporary-config-un-center',
    data () {
      return {
        permissionCodes: '',
        config: {
          breadcrumb: [{
            value: '智慧停车',
            name: 'park-yard'
          }, {
            value: '缴费配置'
          }],
        },
        addCustom: 'parking-month-config-un-modify',

        tableHead: [{
          prop: 'unitPrice',
          label: '单价(元)'
        }, {
          prop: 'paymentCycleText',
          label: '缴费周期'
        }, {
          prop: 'memo',
          label: '备注'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
        },
        operationArr: ['modify', 'delete']
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getList()
    },
    methods: {
      getList () {
        this.$axios.post(api.getParkingPaymentConfigList, {
          configType: 2,
          parkingLotType: 2
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              data.map(v => {
                if (v.paymentCycle === '1') {
                  v.paymentCycleText = '月缴'
                } else if (v.paymentCycle === '2') {
                  v.paymentCycleText = '季缴'
                } else if (v.paymentCycle === '3') {
                  v.paymentCycleText = '半年缴'
                } else if (v.paymentCycle === '4') {
                  v.paymentCycleText = '年缴'
                }
              })
              this.total = data.length
              this.tableData = data
            }
          })
          .catch(errorHandler('获取配置数据失败'))
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getList()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getList()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        let _data = {}
        this.tableData.map(v => {
          if (v.code === code) {
            _data = v
          }
        })
        this.$router.push({
          name: 'parking-month-config-un-modify',
          params: {
            code: _data.code,
            unitPrice: _data.unitPrice,
            paymentCycle: _data.paymentCycle,
            memo: _data.memo,
          }
        })
      },
      deleteLine (code) {
        this.$axios.post(api.deleteParkingPaymentConfig, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.getList()
            }
          })
          .catch(errorHandler('删除配置失败'))
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/ParkingService/ParkingConfig/ParkingMonthConfigUnCenter.vue